/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeProducedMaterialPrintInfoEntry } from '../../models/change-produced-material-print-info-entry';

export interface ChangeProducedMaterialPrintInfo$Params {
  producedMaterialId: number;
      body: ChangeProducedMaterialPrintInfoEntry
}

export function changeProducedMaterialPrintInfo(http: HttpClient, rootUrl: string, params: ChangeProducedMaterialPrintInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeProducedMaterialPrintInfo.PATH, 'post');
  if (params) {
    rb.path('producedMaterialId', params.producedMaterialId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeProducedMaterialPrintInfo.PATH = '/api/v1/ProducedMaterial/{producedMaterialId}/ChangeProducedMaterialPrintInfo';
